import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { useTranslate } from '~/shared/context/use-translate';

import type { ProfileForm } from '../types';
import { useScrollToInvalidSkill } from './use-scroll-to-invalid-skill';

export const useReportMissingSkillLevels = (formMethods: UseFormReturn<ProfileForm>): (() => void) => {
    const translate = useTranslate();
    const { enqueueSnackbar } = useSnackbar();
    const scrollToInvalidSkill = useScrollToInvalidSkill(formMethods);

    return useCallback(() => {
        enqueueSnackbar(translate('pages.job-architecture-v2.validation-error-skills-missing-proficiency'), {
            variant: 'error',
        });

        scrollToInvalidSkill();
    }, [enqueueSnackbar, scrollToInvalidSkill, translate]);
};
